/*
  WAENN — Seguimiento de enlaces de referido para THE W.

  Cada clienta logueada tiene un enlace personal en THE W:
  https://waenn.com/?ref=<su-id-de-cliente>. Este script:
  1) Detecta ?ref=<id> en la URL al aterrizar en cualquier pagina de la
     tienda (no solo la home), y lo guarda 30 dias en localStorage.
  2) Adjunta ese valor como atributo del carrito (cart.attributes.ref) via
     la Ajax Cart API de Shopify, tanto en el momento de aterrizar como en
     cargas de pagina posteriores mientras el valor siga guardado -- asi
     sobrevive aunque el carrito se cree/actualice mas tarde.
  3) El atributo "ref" queda grabado en el pedido final (los atributos de
     carrito pasan a ser atributos del pedido en Shopify). Una
     automatizacion de Shopify Flow (configurada por WAENN en
     Admin > Apps > Flow) lee ese atributo cuando se crea un pedido nuevo y
     sube los puntos bonus a la clienta que invito -- logica de negocio
     fuera de este archivo, ver instrucciones aparte.

  No se usan cookies de terceros ni se envian datos fuera de la propia
  tienda Shopify.
*/
(function () {
  var STORAGE_KEY = 'waenn_ref';
  var STORAGE_DAYS = 30;

  function getStoredRef() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.value || !data.expires) return null;
      if (Date.now() > data.expires) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data.value;
    } catch (e) {
      return null;
    }
  }

  function storeRef(value) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          value: value,
          expires: Date.now() + STORAGE_DAYS * 24 * 60 * 60 * 1000
        })
      );
    } catch (e) {}
  }

  function attachRefToCart(value) {
    if (!value) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ref: value } })
    }).catch(function () {});
  }

  var params = new URLSearchParams(window.location.search);
  var urlRef = params.get('ref');

  if (urlRef && /^\d+$/.test(urlRef)) {
    storeRef(urlRef);
    attachRefToCart(urlRef);
  } else {
    var stored = getStoredRef();
    if (stored) {
      attachRefToCart(stored);
    }
  }
})();
